// ====================================================
// More Templates: https://www.ebenmonney.com/templates
// Email: support@ebenmonney.com
// ====================================================

import { enableProdMode, provideZoneChangeDetection, ErrorHandler, importProvidersFrom } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { appConfig, getBaseUrl } from './app/app.config';
import { environment } from './environments/environment';
import { PERFECT_SCROLLBAR_CONFIG, PerfectScrollbarConfigInterface } from 'ngx-perfect-scrollbar';
//import { GA_TOKEN, GoogleAnalyticsModule } from 'angular-ga';
import { AppErrorHandler } from './app/app-error.handler';
import { AlertService } from './app/services/alert.service';
import { ConfigurationService } from './app/services/configuration.service';
import { AppTitleService } from './app/services/app-title.service';
import { AppTranslationService, TranslateLanguageLoader } from './app/services/app-translation.service';
import { NotificationService } from './app/services/notification.service';
import { NotificationEndpoint } from './app/services/notification-endpoint.service';
import { AccountService } from './app/services/account.service';
import { AccountEndpoint } from './app/services/account-endpoint.service';
import { LocalStoreManager } from './app/services/local-store-manager.service';
import { EndpointFactory } from './app/services/endpoint-factory.service';
import { CompletionService } from './app/services/completion.service';
import { PresentationToolsComponent } from './app/services/presentation-tools.component';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { HammerModule, bootstrapApplication, provideClientHydration } from '@angular/platform-browser';
import { provideAnimations } from '@angular/platform-browser/animations';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
//import { ImageUploadModule } from 'angular2-image-upload';
import { SharedModule } from './app/components/main/shared.module';
//import { CookieLawModule } from 'angular2-cookie-law';
import { CookieService } from 'ngx-cookie-service';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatDialogModule } from '@angular/material/dialog';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { AppComponent } from './app/components/app.component';
import { provideToastr, ToastrModule } from 'ngx-toastr';
import { register } from 'swiper/element/bundle';
import { CookieBanner } from './app/cookie-banner/cookie-banner';
import { provideServerRendering } from '@angular/ssr';
import { AuthService } from './app/services/auth.service';
register();

const DEFAULT_PERFECT_SCROLLBAR_CONFIG: PerfectScrollbarConfigInterface = {
    suppressScrollX: true
};

if (environment.production) {
  enableProdMode();
}

bootstrapApplication(AppComponent, appConfig)
  .catch(err => console.log(err));
